module.exports = __webpack_public_path__ + "static/img/18.4d5de84.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/18.png
// module id = pr0D
// module chunks = 0